import { Action } from '@ngrx/store'
import * as RolesTypes from './roles.types'
import { Role, Permission } from './roles.interface'

// Fetch Role Types
export class FetchRolesRequest implements Action {
  readonly type = RolesTypes.FETCH_ROLES_REQUEST
  constructor(public payload: any = {}) {}
}

export class FetchRolesSuccess implements Action {
  readonly type = RolesTypes.FETCH_ROLES_SUCCESS
  constructor(
    public payload: Role[],
    public total: number,
    public filtered: number,
  ) {}
}

export class FetchRolesFailure implements Action {
  readonly type = RolesTypes.FETCH_ROLES_FAILURE
  constructor(public payload: any) {}
}

// Fetch Permission Types
export class FetchPermissionsRequest implements Action {
  readonly type = RolesTypes.FETCH_PERMISSIONS_REQUEST
  _REQUEST
  constructor(public payload: any = {}) {}
}

export class FetchPermissionsSuccess implements Action {
  readonly type = RolesTypes.FETCH_PERMISSIONS_SUCCESS
  _SUCCESS
  constructor(public payload: Permission[]) {}
}

export class FetchPermissionsFailure implements Action {
  readonly type = RolesTypes.FETCH_PERMISSIONS_FAILURE
  _FAILURE
  constructor(public payload: any) {}
}

// Fetch Role Type
export class FetchRoleRequest implements Action {
  readonly type = RolesTypes.FETCH_ROLE_REQUEST
  constructor(public id: number) {}
}

export class FetchRoleSuccess implements Action {
  readonly type = RolesTypes.FETCH_ROLE_SUCCESS
  constructor(public payload: Role) {}
}

export class FetchRoleFailure implements Action {
  readonly type = RolesTypes.FETCH_ROLE_FAILURE
  constructor(public payload: any) {}
}

// Delete Role Type
export class DeleteRoleRequest implements Action {
  readonly type = RolesTypes.DELETE_ROLE_REQUEST
  constructor(public id: number) {}
}

export class DeleteRoleSuccess implements Action {
  readonly type = RolesTypes.DELETE_ROLE_SUCCESS
  constructor() {}
}

export class DeleteRoleFailure implements Action {
  readonly type = RolesTypes.DELETE_ROLE_FAILURE
  constructor(public payload: any) {}
}

// Create Role Type
export class CreateRoleRequest implements Action {
  readonly type = RolesTypes.CREATE_ROLE_REQUEST
  constructor(public payload) {}
}

export class CreateRoleSuccess implements Action {
  readonly type = RolesTypes.CREATE_ROLE_SUCCESS
  constructor() {}
}

export class CreateRoleFailure implements Action {
  readonly type = RolesTypes.CREATE_ROLE_FAILURE
  constructor(public payload: any) {}
}

// Update Role Type
export class UpdateRoleRequest implements Action {
  readonly type = RolesTypes.UPDATE_ROLE_REQUEST
  constructor(public id: number, public payload) {}
}

export class UpdateRoleSuccess implements Action {
  readonly type = RolesTypes.UPDATE_ROLE_SUCCESS
  constructor() {}
}

export class UpdateRoleFailure implements Action {
  readonly type = RolesTypes.UPDATE_ROLE_FAILURE
  constructor(public payload: any) {}
}

// Common

export class UpdateField implements Action {
  readonly type = RolesTypes.UPDATE_FIELD
  public constructor(
    public field: string,
    public value: any,
    public path: string,
  ) {}
}

export class SetDefaultData implements Action {
  readonly type = RolesTypes.SET_DEFAULT_DATA
  public constructor(public path: string) {}
}

export type Actions =
  | UpdateRoleRequest
  | UpdateRoleSuccess
  | UpdateRoleFailure
  | FetchRolesSuccess
  | FetchRolesFailure
  | FetchRolesRequest
  | FetchRoleSuccess
  | FetchRoleFailure
  | FetchRoleRequest
  | CreateRoleRequest
  | CreateRoleSuccess
  | CreateRoleFailure
  | DeleteRoleRequest
  | DeleteRoleSuccess
  | DeleteRoleFailure
  | SetDefaultData
  | UpdateField
  | FetchRolesRequest
  | FetchRolesSuccess
  | FetchRolesFailure
  | FetchPermissionsRequest
  | FetchPermissionsSuccess
  | FetchPermissionsFailure
